<app-content-header backLabel="app_back"
                    (backEvent)="back()"
                    [historyBack]="false"
                    [headline]="'phonenumber_to_port_headline' | i18next"></app-content-header>
<form>
  <div class="row mt-2">
    <div class="col-12 col-md-6">
      <app-icon-card [stretch]="false">
        <div class="h3 red">{{ 'port_number_add_single_number' | i18next}}</div>

          <app-port-number-form
                  submitButtonLabel=""
                  [countryCode]="countryCode"
                  [countryPrefix]="trunkPrefix"
                  (formChange)="onFormChanged($event)"
          ></app-port-number-form>
      </app-icon-card>

    </div>
    <div class="col-12 col-md-6">
      <app-icon-card [stretch]="false" header="port_single_number_example_a_headline"
                     headlineText="port_single_at_number_example_text"></app-icon-card>
    </div>
  </div>
  <div class="row d-flex justify-content-end pb-3 pt-3 form-container-footer">
    <button class="btn btn-primary" (click)="next()"
            type="button"
            [disabled]="!isFormValid">{{ 'app_next' | i18next}}</button>
  </div>
</form>
